import { createFileRoute, Link } from '@tanstack/react-router'
import { DocsArticle, DocsShell } from '@/features/docs/docs-shell'
import { getDocPage } from '@/features/docs/docs-content'
import { Button } from '@/components/ui/button'

export const Route = createFileRoute('/docs/$slug')({
  component: DocsSlugPage,
  notFoundComponent: () => (
    <DocsShell>
      <div className="flex flex-col items-center justify-center gap-4 py-24 text-center">
        <h1 className="text-2xl font-semibold">Page not found</h1>
        <p className="text-muted-foreground">This documentation page does not exist yet.</p>
        <Button asChild variant="outline">
          <Link to="/docs">Browse docs</Link>
        </Button>
      </div>
    </DocsShell>
  ),
})

function DocsSlugPage() {
  const { slug } = Route.useParams()
  const page = getDocPage(slug)

  if (!page) {
    return (
      <DocsShell currentSlug={slug}>
        <div className="flex flex-col items-center justify-center gap-4 py-24 text-center">
          <h1 className="text-2xl font-semibold">Page not found</h1>
          <p className="text-muted-foreground">This documentation page does not exist yet.</p>
          <Button asChild variant="outline">
            <Link to="/docs">Browse docs</Link>
          </Button>
        </div>
      </DocsShell>
    )
  }

  return (
    <DocsShell currentSlug={slug}>
      <DocsArticle page={page} />
    </DocsShell>
  )
}
